import {
  Toast,
  ToastProvider,
  ToastViewport,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
} from "./Toast";
import type { ToastData } from "./useToast";

/** 닫힐 때 흐려지는 시간(globals.css 의 toast-fade-out). 이만큼 기다렸다 목록에서 지운다. */
const EXIT_MS = 400;

export interface ToasterProps {
  toasts: ToastData[];
  onDismiss: (id: string) => void;
  position?:
    | "top-right"
    | "top-left"
    | "bottom-right"
    | "bottom-left"
    | "top-center"
    | "bottom-center";
  /** 한 줄짜리 알약 모양(닫기 버튼 없음). 짧게 떴다 흐려지며 사라진다. */
  compact?: boolean;
}

export function Toaster({
  toasts,
  onDismiss,
  position = "bottom-right",
  compact = false,
}: ToasterProps) {
  return (
    <ToastProvider>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          duration={toast.duration}
          className={
            compact
              ? "pointer-events-auto w-auto gap-2 rounded-full py-2 pl-3 pr-4 shadow-md data-[state=closed]:toast-fade-out"
              : undefined
          }
          onOpenChange={(open) => {
            // 바로 지우면 흐려지는 효과 없이 사라진다.
            if (!open) window.setTimeout(() => onDismiss(toast.id), EXIT_MS);
          }}
        >
          <div className="grid gap-1">
            {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
            {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
          </div>
          {toast.action && (
            <ToastAction altText={toast.action.label} onClick={toast.action.onClick}>
              {toast.action.label}
            </ToastAction>
          )}
          {!compact && <ToastClose />}
        </Toast>
      ))}
      <ToastViewport
        position={position}
        // 알약은 가운데로 모으고, 빈 자리가 아래 화면 클릭을 막지 않게 한다.
        className={compact ? "pointer-events-none items-center" : undefined}
      />
    </ToastProvider>
  );
}
